import type { Resolvers } from '../../../../../generated';

export const resolvers: Resolvers = {
  CollectionField: {
    isEditable: () => true,
  },
};
